module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_serif-bold-web.ttf?f9af9794f622db46aaf9325d552ecd37";